import React from "react";
import "./CustomDateRangePicker.css";

export default function CustomDateRangePicker({ customFrom, customTo, setCustomFrom, setCustomTo }) {
  return (
    <div className="custom-date-range">
      <div className="input-group">
        <label>From</label>
        <input
          type="datetime-local"
          value={customFrom}
          onChange={(e) => setCustomFrom(e.target.value)}
        />
      </div>
      <div className="input-group">
        <label>To</label>
        <input
          type="datetime-local"
          value={customTo}
          onChange={(e) => setCustomTo(e.target.value)}
        />
      </div>
    </div>
  );
}
